import SalemanFormConfig from "./form";
import { SalemanFormData } from "@/formTypes/SalemanFormDataType";
import GenericForm from "../GenericForm";
import { SalemanApi, SalemanDataType } from "@/api/SalemenApi";

type SalemanFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string
}

const SalemanForm = (props: SalemanFormProps) => {

  return (
    <GenericForm<SalemanFormData, SalemanDataType>
      id={props.id}
      formId={props.formId}
      saveRedirectUrl={props.saveRedirectUrl}
      formConfig={SalemanFormConfig}
      getById={(...arg) => SalemanApi.get(...arg)}
      createFn={(...arg) => SalemanApi.create(...arg)}
      updateFn={(...arg) => SalemanApi.update(...arg)}
      successMessage="El vendedor ha sido almacenada correctamente"
      errorMessage="No fue posible almacenar la información del vendedor"
    />
  )
}

export default SalemanForm;